<template>
    <div class="hotel-changes">
        <div class="hotel-changes-container">
            <list-hotel-pending-changes />
        </div>
    </div>
</template>

<script>
import ListHotelPendingChanges from "../../components/HotelPendingChanges/ListHotelPendingChanges";

export default {
    name: "HotelNeedChangesList",
    components: {ListHotelPendingChanges}
}
</script>

<style lang="scss" scoped>
.hotel-changes {
    background-color: #f0f0f0;
    height: 100%;
    &-container {
        padding: 20px;
        width: 100%;
    }
}
</style>
